import moment from 'moment';

export const hasDatePassed = date => {
  const today = moment();
  return date.isSame(today, 'day') || date.isAfter(today, 'day');
};
export const isDateAfter = (date1, date2) => date1.isAfter(date2, 'day');
export const parseDate = dateString => moment(dateString, 'DD-MM-YYYY');
